import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import LandingPage from "./pages/LandingPage";
import ScavengerHuntPage from "./pages/ScavengerHuntPage";
import CongratsPage from "./pages/CongratsPage";
import { ScavengerHunt } from "./data/ScavengerHunts";
import { WintiGayesHalloween2025 } from "./data/WintiGayesHalloween2025";
import Puzzle1 from "./pages/2025puzzles/puzzle1";
import Puzzle2 from "./pages/2025puzzles/puzzle2";
import Puzzle3 from "./pages/2025puzzles/puzzle3";
import Puzzle4 from "./pages/2025puzzles/puzzle4";
import Puzzle6 from "./pages/2025puzzles/puzzle6";
import Puzzle5 from "./pages/2025puzzles/puzzle5";
import Puzzle7 from "./pages/2025puzzles/puzzle7";
import { WintiGayesHalloween } from "./data/WintiGayesHalloween2024";

function App() {
  const hunt: ScavengerHunt = WintiGayesHalloween2025;
  const old_hunt: ScavengerHunt = WintiGayesHalloween;
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage title={hunt.title} />} />
        <Route
          path="/archive/2024"
          element={
            <ScavengerHuntPage
              solutionCode={old_hunt.solutionCode}
              text={old_hunt.huntingText}
            />
          }
        />
        <Route
          path="/hunt"
          element={
            <ScavengerHuntPage
              solutionCode={hunt.solutionCode}
              text={hunt.huntingText}
            />
          }
        />
        <Route
          path="/congrats/:code"
          element={
            <CongratsPage
              solutionCode={hunt.solutionCode}
              text={hunt.congratsText}
            />
          }
        />
        <Route path="/puzzle/1" element={<Puzzle1 />} />
        <Route path="/puzzle/2" element={<Puzzle2 />} />
        <Route path="/puzzle/3" element={<Puzzle3 />} />
        <Route path="/puzzle/4" element={<Puzzle4 />} />
        <Route path="/puzzle/5" element={<Puzzle5 />} />
        <Route path="/puzzle/6" element={<Puzzle6 />} />
        <Route path="/puzzle/7" element={<Puzzle7 />} />
      </Routes>
    </div>
  );
}

export default App;
